import { useQuery } from '@tanstack/react-query';
import { create, windowScheduler, keyResolver } from '@yornaath/batshit';

import { DataLake } from '@graylog/enterprise-api';

const streamDataLakeEnabledStatus = create({
  fetcher: (ids: Array<string>) => DataLake.getEnabledStreamStatuses({ stream_ids: ids }),
  resolver: keyResolver('stream_id'),
  scheduler: windowScheduler(10),
});

const useStreamDataLakeEnabledStatus = (
  streamId: string,
): {
  data: boolean;
  refetch: () => void;
  isFetching: boolean;
  isError: boolean;
} => {
  const { data, refetch, isFetching, isError } = useQuery(
    ['data-lake-config', streamId, 'enabled'],
    () => streamDataLakeEnabledStatus.fetch(streamId),
    {
      keepPreviousData: true,
    },
  );

  return {
    data: data?.enabled,
    refetch,
    isFetching,
    isError,
  };
};

export default useStreamDataLakeEnabledStatus;
